import { Cell } from '@/components/Bicester/Table/Cells/index';
import { TABLE_DEFAULT_DISPLAY } from '@/constants/config';
// import { ServiceStatus } from '@/constants';
import options from '@/utils/options';
import _ from 'lodash';
import React from 'react';
import { ItemDataType } from 'rsuite5/esm/@types/common';

type StatusType = 'bool';

const byTypeGetData = (type: StatusType) =>
  options<{ label: string; value: any }[], string>(
    {
      bool: () => [
        { label: '是', value: 1 },
        { label: '否', value: 0 },
      ],
    },
    type
  );

export interface StatusCellProps {
  rowData?: BaseObject<any>;
  dataKey: string;
  statusType?: StatusType;
  statusOptionsData?: ItemDataType[];
}

const StatusCell = ({
  rowData,
  dataKey,
  statusType,
  statusOptionsData,
  ...props
}: StatusCellProps) => {
  const status = _.get(rowData, dataKey);

  return (
    <Cell {...props}>
      {statusOptionsData
        ? statusOptionsData?.find((option) => option.value === status)?.label ||
          TABLE_DEFAULT_DISPLAY
        : _.find(byTypeGetData(statusType), { value: status })?.label || TABLE_DEFAULT_DISPLAY}
    </Cell>
  );
};

export default StatusCell;
